// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iphTYUmb7bEYP_LWHI2Y {
    padding: 24px 28px 20px;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
    background: var(--curio-page-bg);
    max-height: 85vh;
    overflow-y: auto;
    min-width: 440px;
}

.MWAvkPUBLCWzqj7oqfex {
    margin: 0 32px 6px 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--curio-text-primary);
}

.RlANQEPDLR5KdEYHkZgg {
    margin: 0 0 18px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.4;
}

.zb5hAZW6IDv9au__EK1L {
    margin-bottom: 14px;
}

.XEp3gjssJy704PVBSskg {
    display: block;
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--curio-text-muted);
    margin-bottom: 6px;
}

.muSgaDoUH6ATq2Xnqk0d {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    font: inherit;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
}

.KFwurBwEJrEv8UWSEpv9 {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    font: inherit;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
    min-height: 64px;
    resize: vertical;
}

.xdvfCBw8wdyPEHUBIg4g {
    font-family: var(--curio-font-mono);
    min-height: 180px;
}

._yPTq3_9EcEAzY8pK0uk {
    margin: 14px 0 18px;
    padding: 12px 14px;
    border: 1px dashed var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-secondary);
}

.fX0iXjqvAEk_BoM5dMp2 {
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--curio-text-muted);
    margin: 0 0 8px;
}

.HMCDQ9MFQJlvR5AOm47L {
    margin: 2px 0;
    font-family: var(--curio-font-mono);
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-primary);
}

.q9Qydt7FFXm3ERcX3wGq {
    margin: 0;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
}

.c4NcjB25EmxdPuU_woLE {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 18px;
}

.SrWOvLQdyt2jVLSvbO5O,
.gJRANRGmxChfSTApHmPE {
    padding: 8px 18px;
    border-radius: var(--curio-radius-md);
    font: inherit;
    font-size: var(--curio-font-size-md);
    cursor: pointer;
    border: 1px solid var(--curio-border-strong);
}

.SrWOvLQdyt2jVLSvbO5O {
    background: transparent;
    color: var(--curio-text-primary);
}

.gJRANRGmxChfSTApHmPE {
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    border-color: var(--curio-top-bar-bg);
}

.gJRANRGmxChfSTApHmPE:hover:not(:disabled) {
    background: var(--curio-top-bar-bg-hover);
    border-color: var(--curio-top-bar-bg-hover);
}

.gJRANRGmxChfSTApHmPE:disabled,
.SrWOvLQdyt2jVLSvbO5O:disabled {
    opacity: 0.5;
    cursor: default;
}

.lwn7FnJY2TU5JLDYebAq {
    margin: 10px 0 0;
    color: var(--curio-danger);
    font-size: var(--curio-font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/PackageMetadataModal.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,qCAAqC;IACrC,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oCAAoC;AACxC","sourcesContent":[".content {\n    padding: 24px 28px 20px;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n    background: var(--curio-page-bg);\n    max-height: 85vh;\n    overflow-y: auto;\n    min-width: 440px;\n}\n\n.title {\n    margin: 0 32px 6px 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.subtitle {\n    margin: 0 0 18px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.4;\n}\n\n.field {\n    margin-bottom: 14px;\n}\n\n.fieldLabel {\n    display: block;\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--curio-text-muted);\n    margin-bottom: 6px;\n}\n\n.input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 9px 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n}\n\n.textarea {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 9px 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n    min-height: 64px;\n    resize: vertical;\n}\n\n.readme {\n    font-family: var(--curio-font-mono);\n    min-height: 180px;\n}\n\n.depsBlock {\n    margin: 14px 0 18px;\n    padding: 12px 14px;\n    border: 1px dashed var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-secondary);\n}\n\n.depsTitle {\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--curio-text-muted);\n    margin: 0 0 8px;\n}\n\n.depsRow {\n    margin: 2px 0;\n    font-family: var(--curio-font-mono);\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-primary);\n}\n\n.depsEmpty {\n    margin: 0;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 18px;\n}\n\n.ghostBtn,\n.primaryBtn {\n    padding: 8px 18px;\n    border-radius: var(--curio-radius-md);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    cursor: pointer;\n    border: 1px solid var(--curio-border-strong);\n}\n\n.ghostBtn {\n    background: transparent;\n    color: var(--curio-text-primary);\n}\n\n.primaryBtn {\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    border-color: var(--curio-top-bar-bg);\n}\n\n.primaryBtn:hover:not(:disabled) {\n    background: var(--curio-top-bar-bg-hover);\n    border-color: var(--curio-top-bar-bg-hover);\n}\n\n.primaryBtn:disabled,\n.ghostBtn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.error {\n    margin: 10px 0 0;\n    color: var(--curio-danger);\n    font-size: var(--curio-font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `iphTYUmb7bEYP_LWHI2Y`,
	"title": `MWAvkPUBLCWzqj7oqfex`,
	"subtitle": `RlANQEPDLR5KdEYHkZgg`,
	"field": `zb5hAZW6IDv9au__EK1L`,
	"fieldLabel": `XEp3gjssJy704PVBSskg`,
	"input": `muSgaDoUH6ATq2Xnqk0d`,
	"textarea": `KFwurBwEJrEv8UWSEpv9`,
	"readme": `xdvfCBw8wdyPEHUBIg4g`,
	"depsBlock": `_yPTq3_9EcEAzY8pK0uk`,
	"depsTitle": `fX0iXjqvAEk_BoM5dMp2`,
	"depsRow": `HMCDQ9MFQJlvR5AOm47L`,
	"depsEmpty": `q9Qydt7FFXm3ERcX3wGq`,
	"footer": `c4NcjB25EmxdPuU_woLE`,
	"ghostBtn": `SrWOvLQdyt2jVLSvbO5O`,
	"primaryBtn": `gJRANRGmxChfSTApHmPE`,
	"error": `lwn7FnJY2TU5JLDYebAq`
};
export default ___CSS_LOADER_EXPORT___;
